<template>
<div class="modalPopupLayout" :class="{'active':visible}">
	<div v-show="docType=='option'" class="documentOption contentWrap">
		<h2 class="title">{{ readonly ? '문서설정' : '문서정보' }}</h2>
		<div class="overflow content">
			<div class="option">
				<h3>&#183; 공개정보 설정</h3>
				<div class="btns">
					<TypeSelector
						v-if="typeChanger"
						@change="(item)=>changeType(item)"
						:selected="processType"
					>
					</TypeSelector>
					<button v-if="!readonly" @click="processDelete">공정도 삭제</button>
				</div>
				<!--v-show="apiType === 'process'"-->
				<table>
					<thead>
						<tr>
							<th>항목</th>
							<th>정보</th>
							<th v-if="!readonly">공개</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="value, key in defaultData" v-if="userData[key] || activeData[key]">
							<td>{{value.name}}</td>
							<td>{{!userData[key]?activeData[key]:userData[key]}}</td>
							<td v-if="!readonly"></td>
						</tr>
						<!-- 읽기 전용이 아닌 경우 노출 -->
						<tr v-for="value, key in userTableData" v-if="!readonly">
							<td>{{value.name}}</td>
							<td>{{userData[key]}}</td>
							<td>
								<input type="checkbox" v-model="activeData[value.activeKey]" />
							</td>
						</tr>
						<!-- 읽기 전용 일 경우 노출 -->
						<tr v-for="value, key in userTableData" v-if="readonly && activeData[value.activeKey]">
							<td>{{value.name}}</td>
							<td>{{userData[key]}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="!readonly" class="option">
				<h3>&#183; 공저자 정보 (총 {{myCoauthors.length}}명)</h3>
				<button @click="docType='coauthor'">추가/삭제 하기</button>
				<table>
					<thead>
						<th>사용자 ID</th>
						<th>이름</th>
						<th>권한</th>
					</thead>
					<tbody>
						<tr>
							<td>{{userData['loginId']}}</td><td>{{userData['name']}}</td><td>관리자</td>
						</tr>
						<tr v-for="coauthor in myCoauthors">
							<td>{{coauthor.loginId}}</td><td>{{coauthor.name}}</td><td>공저자권한</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<button class="close" @click="close">닫기</button>
		<div class="ctrl">
			<button class="confirm" @click="confirmCheck">완료</button>
		</div>
	</div>
	<div v-show="docType=='coauthor'" class="documentOption contentWrap">
		<div class="title">
			<h2>공저자 추가/삭제</h2>
			<div class="searchInput">
				<span>검색어</span>
				<input type="text" @keydown.enter="getCollaborator" v-model="collaboratorName" />
				<button @click="getCollaborator">검색</button>
			</div>
		</div>
		<div class="overflow content">
			<div class="option">
				<table>
					<thead>
						<th>사용자 ID</th>
						<th>이름</th>
						<th>소속</th>
						<th>선택</th>
					</thead>
					<tbody>
						<tr v-for="coauthor in coauthors">
							<td>{{coauthor.loginId}}</td>
							<td>{{coauthor.name}}</td>
							<td>{{coauthor.companyName}}</td>
							<td>
								<input type="checkbox" :readonly="coauthor.readOnly" :checked="coauthor.collaborator" @change="(e)=>{
									coauthor.collaborator = e.target.checked; 
									addCollaborator(e, coauthor);
								}">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="ctrl">
			<Pagination :pageCnt="pagingInfo.no" :pageTotalCnt="pagingInfo.total" :size="pagingInfo.size" @click="selectPageNo"/>
			<button class="confirm" @click="collaboratorModify(false)">저장</button>	
		</div>
		<button class="close" @click="collaboratorModify(true)">닫기</button>
	</div>

<!--	<div v-show="processDeleteAlert" class="alertPopup">
		<div class="layout">
			<h2 class="title">{{ apiType === 'process' ? '공정도를' : '프로토콜을' }} 삭제하시겠습니까?</h2>
			<p class="content">해당 공정도에서 생성된 프로토콜도<br> 함께 삭제됩니다.</p>
			<div class="buttons-wrap">
				<btn-link :style="{minWidth: '60px'}" @click="processDeleteAlert=false" >취소</btn-link>
				<btn-link color="blue" :style="{minWidth: '80px'}" @click="processDelete" >삭제하기</btn-link>
			</div>
		</div>
  </div>-->
  <Loading :visible="loading" type="fixed"/>
</div>
</template>

<script>
	import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
	import Pagination from '../../common/Pagination.vue'
	import BtnLink from '@components/btns/BtnLink.vue'
	import TypeSelector from '@common/selects/TypeSelector';
	import Loading from '@common/loading.vue'

	export default {
		props: {
			readonly: {
				type: Boolean,
				default () {
					return false
				}
			},
			apiType: {
				type: String,
				default: 'process'
			},
			ProcessId : {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				loading: false,
				docType: 'option',
				processType:"",
				visible: false,
				// coauthors: [],

				typeChanger : false,

				collaboratorName: '',
				coauthors: [],
				defaultData: {
					processId: { name: '공정도 번호', value: '' }, 
					protocolId: { name: '프로토콜 번호', value: '' }, 
					loginId: { name: '사용자 ID', value: '' },
					name: { name: '이름', value: '' },
				},
				userTableData: {
					email: {name:'이메일', value:'', status: false, activeKey: 'emailActive'},
					companyName: {name:'소속(직장명)', value:'', status: false, activeKey: 'companyNameActive'},
					mobile : {name:'전화', value:'', status: false, activeKey: 'mobileActive'},
					position : {name:'직책', value:'', status: false, activeKey: 'positionActive'},
					/*researchPart : {name:'연구분야', value:'', status: false, activeKey: 'researchPartActive'},
					researchNumber : {name:'국가연구자번호', value:'', status: false, activeKey: 'researchNumberActive'},*/
				},
				userData:{},
				activeData:{},
				processDeleteAlert: false,
				Api: null,
				collaboratorGroup:[],
				pagingInfo: {
					no: 1,
					total: 0,
					size: 9,
				},
				myCoauthors: [],
				modifyCoauthors: new Map(),
			}
		},
		mixins:[CommNew],
		components: {
			Pagination,
			BtnLink,
			TypeSelector,
			Loading,
		},
		computed: {
			...commNewMapGetters(['status']),

			getIdType () {
				let idType = null ; 
				switch ( this.apiType ) {
					case 'process' : 
						return this.$route.query.processId ; 
						break ; 
					case 'protocol' : {
						// 수정 모드에서 PROCESS_INFO.protocols가 아직 없거나
						// 응답 키가 protocolId인 경우에도 동작하도록 보강
						const routeProtocolId = this.$route.query.protocolId ;
						const protocols = ( this.PROCESS_INFO && this.PROCESS_INFO.protocols ) || [] ;
						protocols.map( p => {
							if ( routeProtocolId == p.id || routeProtocolId == p.protocolId ) {
								idType = p.id != null ? p.id : p.protocolId ;
							}
						})
						return idType != null ? idType : ( routeProtocolId || null ) ;
					}
				}
			} , 
		},
		watch: {
			'status.DocumentOption': {
				// deep: true,
				// immediate: true,
				async handler (value) {
					if(value === true) this.show()
				}
			},
			docType (value) {
				if(value == 'coauthor') {
					this.getCollaborator();
				}else {
					this.collaboratorList();
				}
			}
		},
		async mounted() {
			this.Api = this.$wApi[this.apiType];
			const processDetail = await this.$wApi.process.detail(null, this.$route.query.processId ) ; 
			this.processType = processDetail.processType;
			if( this.processType === 'NORMAL' || this.processType === 'TEMPLATE' ){
				if( this.apiType === 'process' && this.user && this.user.admin && !this.readonly ){
					this.typeChanger = true;
				}
			}
		},
		methods: {
			...commNewMapMutations(['updateStatus']),
			async changeType(item){
				if( !item.before ) return; 

				if( item.before.value != item.option.value ){
					let response = await this.$wApi.process.modify({processType:item.option.value,active:true}, this.PROCESS_INFO.processId);
					if(response) {
						this.$router.replace({
							path : '/process/gate'
						});
					}				

				}
			},
			async confirmCheck(value) {
				const response = await this.Api.optionUser.put(this.activeData, this.getIdType);
				this.close()
			},
			setData(data) {
				
			},
			async show() {
				const idType = this.getIdType ;
				if ( idType == null ) {
					this.updateStatus({'DocumentOption' : false});
					window.alert('문서 정보를 불러올 수 없습니다. 화면을 새로고침한 후 다시 시도해주세요.');
					return;
				}
				try {
					let data = await this.Api.optionUser.get(null, idType);

					this.userData = data.user;
					this.activeData = data;
					this.visible = true;
					this.collaboratorList();
				} catch (error) {
					this.updateStatus({'DocumentOption' : false});
					window.alert('문서설정을 여는 중 오류가 발생했습니다.');
				}
			},
			close() {
				this.visible = false;
				this.updateStatus({'DocumentOption' : false})
			},
			async processDelete() {
				try {
          if(!await window.confirm("해당 공정도를 삭제하시겠습니까?\n공정도 삭제 시 기존에 공개된 실험입력 공정도도 삭제됩니다.")) return;
					this.loading = true;
					let response = null;
					let msg = "";
					let path = "";
					
					switch (this.$route.query.editorType) {
						case "process" :
							await this.$wApi.process.autoSave.create({processId: this.$route.query.processId});
							response = await this.$wApi.process.deactivate({processId : this.$route.query.processId});
							break;
						case "protocol" :
							await this.$wApi.protocol.autoSave.create({protocolId: this.$route.query.protocolId});
							response = await this.$wApi.protocol.deactivate({protocolId: this.$route.query.protocolId});
							break;
					}

					if (response?.error || response == null) {
						switch (this.$route.query.editorType) {
							case "process" :
								msg = "공정도를 ";
								break;
							case "protocol" :
								msg = "프로토콜을 ";
								break;
						}
						msg = msg + "삭제중 오류가 발생했습니다. <br>잠시 후 다시 시도해 주세요.";
						await window.alert(msg);
					} else {
						const processDetail = await this.$wApi.process.detail(null, this.$route.query.processId);
						switch (this.$route.query.editorType) {
							case "process" :
								msg = "공정도가 ";
								path = "/process/gate";
								break;
							case "protocol" :
								msg = "프로토콜이 ";
								if(processDetail.processType == "NORMAL"){
									path = "/protocol/editor?processId=";
									path = path + this.$route.query.processId;
									path = path + "&editorType=protocol&protocolId";
								}else{
									path = "/protocol/gate";
								}
								break;
						}
						msg = msg + "삭제 되었습니다.";
						await window.alert(msg);
						this.$router.replace({
							path : path,
						});
						await this.status.issueListStatus.reload();
					}
					this.processDeleteAlert = false;
					this.loading = false;
					this.close();
				} catch (error) {
					this.processDeleteAlert = false;
					this.loading = false;
					this.close();
				}
			},
			async getCollaborator() {
				try {
					this.loading = true;
					let res = null;
					if(this.apiType === "process") {
						res = await this.$wApi.process.collaborator.get({
							query: this.collaboratorName,
							processId: this.$route.query.processId || this.ProcessId,
							isCollaborator: 0,
							collaboratorUserId: this.userData['loginId'],
						});
						// console.log(res)
						if (res.code === "400") {
							window.alert(res.message);
						} else {
							this.makeCollaboratorGroup(res);
							this.coauthors = this.collaboratorGroup[0];
							this.selectPageNo(null);
						}
					}else if(this.apiType === "protocol"){
						res = await this.$wApi.protocol.collaborator.get({
							query: this.collaboratorName,
							protocolId: this.activeData.protocolId,
							isCollaborator: 0,
							collaboratorUserId: this.userData['loginId'],
						});
						// console.log(res)
						if (res.code === "400") {
							window.alert(res.message);
						} else {
							this.makeCollaboratorGroup(res);
							this.coauthors = this.collaboratorGroup[0];
							this.selectPageNo(null);
						}
					}
					this.loading = false;
				} catch (error) {
					this.loading = false;
				}
			},
			addCollaborator(e, target) {
				if( e.target.checked === true ) {
					if(this.apiType === "process") {
						target.processId = this.$route.query.processId
					}else if(this.apiType === "protocol") {
						target.protocolId = this.activeData.protocolId;
					}
					this.modifyCoauthors.set(target.userId,{eventOpt: "add", data: target});
				} else {
					if(this.apiType === "process") {
						target.processId = this.$route.query.processId
						this.modifyCoauthors.set(target.userId,{eventOpt:"delete",data:{processId: target.processId,userId: target.userId,}});
					}else if(this.apiType === "protocol"){
						target.protocolId = this.activeData.protocolId;
						this.modifyCoauthors.set(target.userId,{eventOpt:"delete",data:{protocolId: target.protocolId,userId: target.userId,}});
					}
				}
			},
			makeCollaboratorGroup(coauthors, groupCnt=10) {
				const group = [];
				let count = 0;
				for(const coauthor of coauthors) {
					if(count%groupCnt === 0) {
						group[ Math.floor( count/groupCnt ) ] = []
					}
					group[ Math.floor( count/groupCnt ) ][count%groupCnt] = coauthor;
					count++;
				}
				this.collaboratorGroup = group;
				this.pagingInfo.no = 1;
				this.pagingInfo.total = this.collaboratorGroup.length - 1;
			},
			async selectPageNo(no) {
				if(no !== null) {
					this.loading = true;
					this.pagingInfo.no = no;
					// 1 page 클릭시 0 번째로 이동되어야 됨.
					this.coauthors = this.collaboratorGroup[no-1];
					if (this.coauthors == null) {
						this.loading = false;
						return;
					}
				}
				// 여기서 check 확인 및 처리.
				for await (const coauthor of this.coauthors){
					// 본인의 데이터일 경우.
					if(this.userData['loginId'] == coauthor.loginId){
						coauthor.collaborator = true;
					}
					for (const myCoauthor of this.myCoauthors) {
						if(myCoauthor.loginId == coauthor.loginId){
							coauthor.collaborator = true;	
						}
					}
				}
				for await (const coauthor of this.coauthors){
					if (this.modifyCoauthors.has(coauthor.userId) && this.modifyCoauthors.get(coauthor.userId).eventOpt == "add"){
						coauthor.collaborator = true;
					}else if (this.modifyCoauthors.has(coauthor.userId) && this.modifyCoauthors.get(coauthor.userId).eventOpt == "delete"){
						coauthor.collaborator = false;
					}
				}
				this.loading = false;
			},
			async collaboratorList() {
				this.loading = true;
				let res = null;
				if(this.apiType === "process") {
					res = await this.$wApi.process.collaborator.get({
						query: '',
						processId: this.$route.query.processId,
						isCollaborator: 1,
						collaboratorUserId: this.userData['loginId'],
					});
				}else if(this.apiType === "protocol") {
					// 프로토콜 문서설정에서도 공저자 목록 조회 (기존: 미처리로 null → 렌더 오류)
					res = await this.$wApi.protocol.collaborator.get({
						query: '',
						protocolId: this.activeData.protocolId || this.$route.query.protocolId,
						isCollaborator: 1,
						collaboratorUserId: this.userData['loginId'],
					});
				}
				this.myCoauthors = res || [];
				this.loading = false;
			},
			async collaboratorModify(closeFlag){
				if(closeFlag){
					if(await window.confirm("수정된 공저자 정보를 저장하지 않고,<br/>팝업을 종료하시겠습니까?<br/><br/><b>(저장시 아래 \"저장\" 버튼을 클릭해 주세요.)</b>")) {
						this.modifyCoauthors.clear();
						this.docType = 'option';
						return;
					}else{
						return;
					}
				}else{
					this.loading = true;
					let tempModifyCoauthors = new Map();
					if(this.myCoauthors.length > 0) {
						for (const myCoauthor of this.myCoauthors) {
							for await (const modifyCoauthor of this.modifyCoauthors) {
								const key 	= modifyCoauthor[0];
								const value = modifyCoauthor[1];
								if(this.modifyCoauthors.has(myCoauthor.userId) && value.eventOpt == "add"){
									this.modifyCoauthors.delete(myCoauthor.userId);
									break;
								}else if(this.modifyCoauthors.has(myCoauthor.userId) && value.eventOpt == "delete"){
									this.modifyCoauthors.delete(myCoauthor.userId);
									tempModifyCoauthors.set(key,value);
									break;
								}
							}
						}
						for await (const modifyCoauthor of this.modifyCoauthors) {
							const key 	= modifyCoauthor[0];
							const value = modifyCoauthor[1];
							tempModifyCoauthors.set(key,value);
						}
					}else if(this.myCoauthors.length == 0){
						for await (const modifyCoauthor of this.modifyCoauthors) {
							const key = modifyCoauthor[0];
							const value = modifyCoauthor[1];
							if(value.eventOpt == "add"){
								tempModifyCoauthors.set(key,value);
							}
						}
					}
					this.modifyCoauthors.clear();
					this.modifyCoauthors = tempModifyCoauthors;
					for await (const modifyCoauthor of this.modifyCoauthors) {
						this.Api.collaborator[modifyCoauthor[1].eventOpt](modifyCoauthor[1].eventOpt == "add" ? [modifyCoauthor[1].data] : modifyCoauthor[1].data);
					}
					this.modifyCoauthors.clear();
					
					// docType변경을 watch 에서 확인한 뒤 this.collaboratorList()를 호출하여 mycoauthor를 수정함.
					// 하지만 데이터 수정 타이밍의 오차로 정상 작동하지 않는 경우가 있기 때문에 이전에 임의로 호출. 
					await this.collaboratorList();
					
					this.loading = false;
					this.docType = 'option';
				}
			}
		}
	}
</script>

<style lang="scss">
	.modalPopupLayout {
		@include modalLayoutBlur();
		.overflow{
			height: 100%;
			.btns{
				z-index:1;
			}
		}
	}
	.documentOption {
		min-width: 700px;
		padding: 24px;
		background-color: #fff;
		max-height: 90%;
		.searchInput {
			display: inline-flex; align-items: center; gap: 8px;
			margin-top: 30px;
			font-size: 14px;
			input {
				width: 400px;
				height: 32px;
				border-radius: 4px;
				border: 1px solid #999;
				flex-shrink: 2;
				padding: 0 50px 0 10px;
			}
			button {
				flex-shrink: 0;
				position: relative; left: -50px;
				width: 40px; height: 40px;
				font-size: 0;
				background: url('../../../assets/icons/magnify.svg') right 10px center no-repeat;
			}
		}
		.option {
			display: flex; flex-wrap: wrap; align-items: center;
			justify-content: space-between;
			&+.option {
				margin-top: 62px;
			}
			h3 {
			}
			button {
				padding: 4px 8px;
				color: #666;
				background: #eee;
				font-size: 14px;
			}
			table {
				width: 100%;
				margin-top: 27px;
				font-size: 14px;
				@include text-prt-sb;
				thead {
					// border-bottom: 1px solid #000;
				}
				th {
					position: sticky; top:0;
					width: auto;
					padding: 11px;
					text-align: center;
					box-shadow: inset 0 -1px 0 #333;
					background-color: #fff;
				}
				td {
					padding: 11px;
					border-bottom: 1px solid #ddd;
					text-align: center;

					input[type='checkbox'] {
						width: 20px; height: 20px;
						border: 2px solid #999;
						border-radius: 50%;
						appearance: none;
						&:checked {
							background: url('../../../assets/icons/icon-check-circle.svg') center no-repeat;
							border-color: #000;
						}
						cursor: pointer;
					}
				}
				tr:last-child td { border: 0 }
			}
		}
		.ctrl {
			flex-wrap: wrap;
			margin-top: 30px;
		}
		.buttons {
			grid-area: ctrl; justify-self: center;
			padding: 24px 0 0 0;
		}
		.confirm {
			min-width: 80px;
			padding: 8px;
			border-radius: 5px;
			background-color: #4879BB;
			color: #fff;
		}
		.pagination {
			flex-shrink: 0;
			width: 100%;
		}
		.alertPopup {
			display: flex; align-items: center; justify-content: center;
			position: fixed; top:0; left:0; right:0; bottom:0;
			.layout {
				padding: 24px;
				border: 1px solid #999;
				background: #fff;
			}
			z-index: 5;
			.title {
				margin-bottom: 6px;
			}
			.content {
				font-size: 12px;
				line-height: 24px;
				color: #999;
			}
			.buttons-wrap {
				display: flex; justify-content: center; gap: 8px;
				margin-top: 14px;
			}
		}
	}
</style>